export default __webpack_public_path__ + "media/design-tools.7307a1965ddde5f504995570f901b7c4.svg";